import * as React from 'react';

// import Stores from '../components/Stores';
import { BlogItem, Container, Jumbotron, Section, Loader } from '../modules/modules';
import BlogQuery from '../components/Query/Blog';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import CountryService from '../services/CountryService';

interface IBlogState { }
interface IBlogProps extends RouteComponentProps<{ language: string }> { }

class Blog extends React.Component<IBlogProps> {

  public state: IBlogState;

  constructor(props: IBlogProps) {
    super(props);
    this.state = {};
  }

  public render() {
    const { language } = CountryService.GetInstance();
    return (
      <>
        <Jumbotron background="/img/blog-jumbo.jpg">
          <small>{process.env.REACT_APP_PROJECT_NAME}</small>
          Blog
        </Jumbotron>
        <Section type="jumbo">
          <Container type="md">
            <BlogQuery>
              {({ blogposts: { blogposts, loading } }: any) => {
                if (loading) {
                  return <Loader />;
                }

                return blogposts.map((post: any) => <BlogItem key={post.id} {...post} language={language} />);
              }}
            </BlogQuery>
          </Container>
        </Section>
      </>
    );
  }
}

export default withRouter(Blog);



// WEBPACK FOOTER //
// ./src/pages/Blog.tsx